"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const ui_1 = require("@completeanatomy/ui");
function Draggable({ disabled, className, children, onDragAction }, ref) {
    const [transform, setTransform] = (0, react_1.useState)({ x: 0, y: 0 });
    const position = (0, react_1.useRef)({ x: 0, y: 0 });
    const containerRef = (0, react_1.useRef)();
    const dragged = (0, react_1.useRef)(false);
    (0, react_1.useEffect)(() => {
        if (!containerRef.current) {
            return;
        }
        const onMove = (e) => {
            e.stopPropagation();
            const delta = (0, ui_1.getDelta)((0, ui_1.getPosition)(e), position.current);
            if (Math.abs(delta.x) > 5 || Math.abs(delta.y) > 5) {
                dragged.current = true;
                setTransform(delta);
                onDragAction(ui_1.ActionType.DRAG, delta);
            }
        };
        const onUp = (e) => {
            e.stopPropagation();
            if (dragged.current) {
                const delta = (0, ui_1.getDelta)((0, ui_1.getPosition)(e), position.current);
                onDragAction(ui_1.ActionType.MOUSE_UP, delta);
                setTransform({ x: 0, y: 0 });
            }
            dragged.current = false;
            document.removeEventListener(events.move, onMove);
            document.removeEventListener(events.up, onUp);
        };
        const onDown = (e) => {
            e.stopPropagation();
            if (disabled) {
                return;
            }
            position.current = (0, ui_1.getPosition)(e);
            document.addEventListener(events.move, onMove);
            document.addEventListener(events.up, onUp);
            onDragAction(ui_1.ActionType.MOUSE_DOWN, position.current);
        };
        const element = containerRef.current;
        const events = (0, ui_1.getPointersEvents)();
        element.addEventListener(events.down, onDown);
        return () => {
            element.removeEventListener(events.down, onDown);
        };
    }, [disabled, onDragAction]);
    const setRef = (newRef) => {
        if (ref) {
            const tempRef = ref;
            tempRef.current = newRef;
        }
        if (containerRef) {
            containerRef.current = newRef;
        }
    };
    return ((0, jsx_runtime_1.jsx)(Container, { ref: setRef, style: { transform: `translate(${transform.x}px, ${transform.y}px)` }, className: className, "data-e2e": 'Draggable_Container', children: children }));
}
exports.default = (0, react_1.forwardRef)(Draggable);
const Container = styled_components_1.default.div `
  position: absolute;

  pointer-events: all;
`;
